export async function refresh(auth) {
  // Add 15 seconds to force the refresh of the
  // security token a bit early to avoid the case
  // where the token expires after this check only
  // to be passed to the api to get refused.
  var now = Date.now() + 15000
  if (!auth.secret_exp || now > auth.secret_exp) {
    console.log("Calling Refresh")
    var server_url = new URL(process.env.REACT_APP_API_GATEWAY)
    const myRequest = new Request(`${server_url.origin}/api/refresh`)

    const res = await fetch(myRequest, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${auth.refresh}`
      }
    })

    if (res.ok) {
      const json = await res.json()
      auth.secret = json.security_token
      auth.secret_exp = json.security_exp
      auth.refresh = json.refresh_token
    } else {
      throw new Error(res.status);
    }
  }
}
